// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.case-columns .case-columns-container {
    overflow-x: hidden\\0; /* \\0 for targeting IE 8-11 */
}`, "",{"version":3,"sources":["webpack://./src/less/ie-hacks.css"],"names":[],"mappings":";;AAEA;IACI,oBAAoB,EAAE,6BAA6B;AACvD","sourcesContent":["\n\n.case-columns .case-columns-container {\n    overflow-x: hidden\\0; /* \\0 for targeting IE 8-11 */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
